import React from "react";
import paypal from "../images/paypal.png";
import visa from "../images/visa.png";
import american from "../images/american express.png";
import { useNavigate } from "react-router-dom";
import { products } from "./data";
import { Link } from "react-router-dom";
import { UpcomingData } from "../Components/upcomingData";
function Payments(props) {
  const [userData, setUserData] = React.useState({
    name: "",
    email: "",
    address: "",
    city: "",
    state: "",
    zip: "",
    cardNumber: "",
    expMonth: "",
    expYear: "",
    nameOnCard: "",
    cvv: "",
  });
  const [errorMsg, setErrorMsg] = React.useState({
    userName: "",
    email: "",
    address: "",
    city: "",
    state: "",
    zip: "",
    cardNumber: "",
    expMonth: "",
    expYear: "",
    nameOnCard: "",
    cvv: "",
  });
  const [items, setItems] = React.useState(1);
  const [totalPrice,setTotalPrice] = React.useState(props.total);
  const productId = props.itemId;
  const item = products.find((e) => e.id === parseInt(productId));
  const newItem = item
    ? item
    : UpcomingData.find((e) => e.id === parseInt(productId));
    let intTotalPrice = parseInt(totalPrice);
  const navigate = useNavigate();
    let btnClass = "btn btn-decrement ";
    btnClass += items<=1 &&  " disabled";
    console.log("New Item ",(newItem.price * 0.8) + newItem.delivery);
    console.log("Props Total ",props.total);
  const handleSubmit = (e) => {
    e.preventDefault();
    if (
      userData.name.includes(
        "@" ||
          "&" ||
          "-" ||
          "_" ||
          ":" ||
          ";" ||
          "!" ||
          "%" ||
          "#" ||
          "^" ||
          "*" ||
          "$" ||
          "<" ||
          ">" ||
          "}" ||
          "{" ||
          "[" ||
          "]" ||
          "+"
      )
    ) {
      setErrorMsg({
        ...errorMsg,
        userName: "User Name Must Not Contain Any Special Letters : @ , % , &",
      });
    } else if (
      userData.email.includes(
        "#" ||
          "$" ||
          "*" ||
          "&" ||
          "!" ||
          "<" ||
          ">" ||
          "}" ||
          "{" ||
          "[" ||
          "]" ||
          "+"
      )
    ) {
      setErrorMsg({
        ...errorMsg,
        email: "Please Provide Valid Email Address! ",
      });
    } else if (
      userData.address.includes(
        "@" ||
          "&" ||
          "-" ||
          "_" ||
          ":" ||
          ";" ||
          "!" ||
          "%" ||
          "#" ||
          "^" ||
          "*" ||
          "$" ||
          "<" ||
          ">" ||
          "}" ||
          "{" ||
          "[" ||
          "]" ||
          "+"
      )
    ) {
      setErrorMsg({
        ...errorMsg,
        address: "Invalid Address! ",
      });
    } else if (
      userData.city.includes(
        "@" ||
          "&" ||
          "-" ||
          "_" ||
          ":" ||
          ";" ||
          "!" ||
          "%" ||
          "#" ||
          "^" ||
          "*" ||
          "$" ||
          "<" ||
          ">" ||
          "}" ||
          "{" ||
          "[" ||
          "]" ||
          "+"
      )
    ) {
      setErrorMsg({
        ...errorMsg,
        city: "Invalid City Name! ",
      });
    } else if (
      userData.state.includes(
        "@" ||
          "&" ||
          "-" ||
          "_" ||
          ":" ||
          ";" ||
          "!" ||
          "%" ||
          "#" ||
          "^" ||
          "*" ||
          "$" ||
          "<" ||
          ">" ||
          "}" ||
          "{" ||
          "[" ||
          "]" ||
          "+"
      )
    ) {
      setErrorMsg({
        ...errorMsg,
        state: "Invalid State Name! ",
      });
    } else if (
      userData.zip.includes(
        "@" ||
          "&" ||
          "-" ||
          "_" ||
          ":" ||
          ";" ||
          "!" ||
          "%" ||
          "#" ||
          "^" ||
          "*" ||
          "$" ||
          "<" ||
          ">" ||
          "}" ||
          "{" ||
          "[" ||
          "]" ||
          "+"
      )
    ) {
      setErrorMsg({
        ...errorMsg,
        zip: "Invalid Zip Number! ",
      });
    } else if (
      (userData.zip >= "a" && userData.zip <= "z") ||
      (userData.zip >= "A" && userData.zip <= "Z")
    ) {
      setErrorMsg({
        ...errorMsg,
        zip: "Zip should be a number not English Alphabets! ",
      });
    } else if (
      userData.nameOnCard.includes(
        "@" ||
          "&" ||
          "-" ||
          "_" ||
          ":" ||
          ";" ||
          "!" ||
          "%" ||
          "#" ||
          "^" ||
          "*" ||
          "$" ||
          "<" ||
          ">" ||
          "}" ||
          "{" ||
          "[" ||
          "]" ||
          "+"
      )
    ) {
      setErrorMsg({
        ...errorMsg,
        nameOnCard: "Name Must Not Contain Any Special Letters : @ , % , &",
      });
    } else if (
      userData.cardNumber.includes(
        "@" ||
          "&" ||
          "-" ||
          "_" ||
          ":" ||
          ";" ||
          "!" ||
          "%" ||
          "#" ||
          "^" ||
          "*" ||
          "$" ||
          "<" ||
          ">" ||
          "}" ||
          "{" ||
          "[" ||
          "]" ||
          "+"
      )
    ) {
      setErrorMsg({
        ...errorMsg,
        cardNumber: "Invalid Card Number! ",
      });
    } else if (
      (userData.cardNumber >= "a" && userData.cardNumber <= "z") ||
      (userData.cardNumber >= "A" && userData.cardNumber <= "Z")
    ) {
      setErrorMsg({
        ...errorMsg,
        cardNumber:
          "Card Number should be in numbers not in English Alphabets! ",
      });
    } else if (
      userData.cvv.includes(
        "@" ||
          "&" ||
          "-" ||
          "_" ||
          ":" ||
          ";" ||
          "!" ||
          "%" ||
          "#" ||
          "^" ||
          "*" ||
          "$" ||
          "<" ||
          ">" ||
          "}" ||
          "{" ||
          "[" ||
          "]" ||
          "+"
      )
    ) {
      setErrorMsg({ ...errorMsg, cvv: "Invalid CVV! " });
    } else if (
      (userData.cvv >= "a" && userData.cvv <= "z") ||
      (userData.cvv >= "A" && userData.cvv <= "Z")
    ) {
      setErrorMsg({
        ...errorMsg,
        cvv: "CVV Must be a number not an English Alphabet!",
      });
    } else {
      navigate("/shipped");
    }
    props.handlePayment(userData.name);
    props.payedItem(newItem);
  };
  const handleName = (e) => {
    return setUserData({ ...userData, name: e.target.value });
  };
  return (
    <div className="row">
      <div className="product-details">
        <img src={newItem.img} alt="" />
        <h5>{newItem.name}</h5>
        <Link
          to={
            newItem.id > 12
              ? `/upcoming/${newItem.id}`
              : `/products/${newItem.id}`
          }
        >
          more info
        </Link>
        <div className="pay-item-details">
          <table>
            <thead>
              <th>Amount Of items: </th>
              <th>
                <button className={btnClass} onClick={() =>
                    {
                      setItems(items - 1);
                      setTotalPrice(parseInt(totalPrice) - parseInt(newItem.price * 0.8) );
                    }
                  } 
                  >-</button>
                <button
                  className="btn btn-increment"
                  onClick={() =>
                    {
                      setItems(items + 1);
                      setTotalPrice(parseInt(totalPrice) + parseInt(props.total) - parseInt(newItem.delivery));
                    }
                  }
                >
                  +
                </button>
              </th>
            </thead>
            <tbody>
              <tr>
                <p>{items}</p>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div className="col-75">
        <div className="container">
          <form onSubmit={handleSubmit}>
            <div className="row">
              <div className="col-50">
                <h3>Billing Address</h3>
                <label htmlFor="fname">
                  <i className="fa fa-user"></i> Full Name
                </label>
                <input
                  type="text"
                  id="fname"
                  name="firstname"
                  placeholder="John M. Doe"
                  required
                  value={userData.name}
                  onChange={handleName}
                />
                <p className="error-msg">{errorMsg.userName}</p>
                <label htmlFor="email">
                  <i className="fa fa-envelope" /> Email
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  placeholder="john@example.com"
                  value={userData.email}
                  onChange={(e) =>
                    setUserData({ ...userData, email: e.target.value })
                  }
                  required
                />
                <p className="error-msg">{errorMsg.email}</p>
                <label htmlFor="adr">
                  <i className="fa fa-address-card-o" /> Address
                </label>
                <input
                  type="text"
                  id="adr"
                  name="address"
                  placeholder="542 W. 15th Street"
                  value={userData.address}
                  onChange={(e) =>
                    setUserData({ ...userData, address: e.target.value })
                  }
                  required
                />
                <p className="error-msg">{errorMsg.address}</p>
                <label htmlFor="city">
                  <i className="fa fa-institution" /> City
                </label>
                <input
                  type="text"
                  id="city"
                  name="city"
                  placeholder="New York"
                  list="city-list"
                  value={userData.city}
                  onChange={(e) =>
                    setUserData({ ...userData, city: e.target.value })
                  }
                  minLength="3"
                />
                <p className="error-msg">{errorMsg.city}</p>
                <datalist id="city-list">
                  <option value="Madina">Saudi Arabia</option>
                  <option value="Makkah">Saudi Arabia</option>
                  <option value="London">England</option>
                  <option value="Kabul">Afghanistan</option>
                  <option value="Paris">France</option>
                  <option value="Sydney">Australia</option>
                  <option value="Melbourne">Australia</option>
                  <option value="New York">United States of America</option>
                  <option value="Karachi">Pakistan</option>
                  <option value="Lahore">Pakistan</option>
                  <option value="Delhi">India</option>
                  <option value="Mumbai">India</option>
                  <option value="Kolkata">India</option>
                  <option value="Peshawar">Pakistan</option>
                  <option value="Queeta">Pakistan</option>
                  <option value="Washington D.C">
                    United States of America
                  </option>
                  <option value="Juhanes-burg">South Africa</option>
                  <option value="Harare">Zimbabwe</option>
                  <option value="Auckland">New Zea Land</option>
                  <option value="Dhaka">BanglaDesh</option>
                  <option value="Colombo">Sri Lanka</option>
                  <option value="Multan">Pakistan</option>
                  <option value="Islamabad">Pakistan</option>
                  <option value="Baghdad">Iraq</option>
                  <option value="Panselvaniya">United States of America</option>
                  <option value="Dubai">UAE</option>
                  <option value="Riyadh">Saudi Arabia</option>
                  <option value="Jeddah">Saudi Arabia</option>
                  <option value="San Francisco">
                    United States Of America
                  </option>
                  <option value="CapeTown">South Africa</option>
                  <option value="Beijing">China</option>
                  <option value="Istanbul">Turkey</option>
                  <option value="Berlin">Germany</option>
                  <option value="Mexico City">Mexico</option>
                  <option value="Tokyo">Japan</option>
                  <option value="Sharjah">UAE</option>
                  <option value="Christ Church">New Zea Land</option>
                  <option value="Emirtas">UAE</option>
                  <option value="Faisalabad">Pakistan</option>
                  <option value="Chennai">India</option>
                  <option value="Shimla">India</option>
                  <option value="Jammu Kashmir">India</option>
                  <option value="Kashmir">Pakistan</option>
                  <option value="Perth">Australia</option>
                </datalist>
                <div className="row">
                  <div className="col-50">
                    <label htmlFor="state">State</label>
                    <input
                      type="text"
                      id="state"
                      name="state"
                      placeholder="NY"
                      value={userData.state}
                      onChange={(e) =>
                        setUserData({ ...userData, state: e.target.value })
                      }
                      minLength="3"
                    />
                    <p className="error-msg">{errorMsg.state}</p>
                  </div>
                  <div className="col-50">
                    <label htmlFor="zip">Zip</label>
                    <input
                      type="text"
                      id="zip"
                      name="zip"
                      placeholder="10001"
                      maxLength="5"
                      minLength="4"
                      value={userData.zip}
                      onChange={(e) =>
                        setUserData({ ...userData, zip: e.target.value })
                      }
                    />
                    <p className="error-msg">{errorMsg.zip}</p>
                  </div>
                </div>
              </div>

              <div className="col-50">
                <h3>Payment Method</h3>
                <div className="pay-cards">
                  <input type="radio" id="visa" name="payment-card" required />
                  <label htmlFor="visa">
                    <img src={visa} alt="" />
                  </label>
                  <input type="radio" id="paypal" name="payment-card" />
                  <label htmlFor="paypal">
                    <img src={paypal} alt="" />
                  </label>
                  <input type="radio" id="american" name="payment-card" />
                  <label htmlFor="american">
                    <img src={american} alt="" />
                  </label>
                </div>
                <label htmlFor="cname">Name on Card</label>
                <input
                  type="text"
                  id="cname"
                  name="cardname"
                  placeholder="John More Doe"
                  value={userData.nameOnCard}
                  onChange={(e) =>
                    setUserData({ ...userData, nameOnCard: e.target.value })
                  }
                  required
                  minLength="3"
                  maxLength="25"
                />
                <p className="error-msg">{errorMsg.nameOnCard}</p>
                <label htmlFor="ccnum">Credit card number</label>
                <input
                  type="text"
                  id="ccnum"
                  name="cardnumber"
                  placeholder="1111-2222-3333-4444"
                  minLength="16"
                  maxLength="16"
                  required
                  value={userData.cardNumber}
                  onChange={(e) =>
                    setUserData({ ...userData, cardNumber: e.target.value })
                  }
                />
                <p className="error-msg">{errorMsg.cardNumber}</p>
                <label htmlFor="expmonth">Exp Month & Year</label>
                <input
                  type="month"
                  id="expmonth"
                  name="expmonth"
                  placeholder="September"
                  required
                />
                <div className="row">
                  <div className="col-50">
                    <label htmlFor="cvv">CVV</label>
                    <input
                      type="text"
                      id="cvv"
                      name="cvv"
                      placeholder="352"
                      minLength="3"
                      maxLength="3"
                      required
                      value={userData.cvv}
                      onChange={(e) =>
                        setUserData({ ...userData, cvv: e.target.value })
                      }
                    />
                    <p className="error-msg">{errorMsg.cvv}</p>
                  </div>
                </div>
              </div>
            </div>
            <label>
              <input type="checkbox" name="sameadr" /> Shipping address same as
              billing
            </label>
            <button className="btn-submit btn btn-pay">
              Pay ${intTotalPrice.toFixed(2)}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
export default Payments;
